import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { filter, map, switchMap, tap } from 'rxjs'
import { RegistrationData, RegistrationPatientUserMetadata } from '../types'
import { isNotNull } from './filter'
import { registrationRequest } from './signup'
import { setRegistrationSuccess } from './success'

const [patientRegistrationInput$, setPatientRegistrationInput] = createSignal<{
  input: RegistrationData & RegistrationPatientUserMetadata
  isGuestCheckoutEnabled?: boolean
}>()

// create hook for sharing latest input pending subscription to request observable
const [useLatestPatientRegistrationInput, latestPatientRegistrationInput$] = bind(
  patientRegistrationInput$,
  null
)

export { setPatientRegistrationInput, useLatestPatientRegistrationInput }

export const patientRegistrationRequest$ = latestPatientRegistrationInput$.pipe(
  filter(isNotNull),
  switchMap(({ input, isGuestCheckoutEnabled }) =>
    registrationRequest({
      input,
      isGuestCheckoutEnabled,
    }).pipe(
      map((response) => ({ input, isGuestCheckoutEnabled, response })),
      tap(setRegistrationSuccess)
    )
  )
)
